import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { UnidadesOrganizativa } from '../models/unidadesOrganizativa';
import { switchMap, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/unidadesOrganizativas';

@Injectable({
  providedIn: 'root'
})
export class UnidadesOrganizativaService {
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getBySociedad(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetBySociedad?sociedadId=' + code })
  }

  save(unidadOrganizativa: UnidadesOrganizativa)
  {
    return this._http.post({ url: baseUrl + '/Save', body: unidadOrganizativa });
  }

  delete(id: number)
  {
    return this._http.get({ url: baseUrl + '/Delete?id=' + id});
  }
}
